import React from "react";
import { Button } from "react-bootstrap";
import api from "../../../services/api";
import { formatDateTimeDMY } from "../../../utils/dateFormat";
import { openFetchedFile } from "../../../utils/openFetchedFile";

export const ITINERARY = "ITINERARY";
export const CUSTOMER_ID = "CUSTOMER_ID";

const fetchBookingDocument = async (bookingId, documentId) =>
  (await api.get(`/api/admin/bookings/${bookingId}/documents/${documentId}/file`, { responseType: "blob" })).data;

export function bookingDocumentsOfKind(booking, kind) {
  return (booking?.documents || []).filter((file) => (file.kind || ITINERARY) === kind);
}

/**
 * A booking's uploaded files of one kind: the itinerary plan from lead confirmation (Notes column)
 * or the customer's ID cards from their trip page (User column). `compact` shows one line per file:
 * label, upload time and the buttons — no file name or uploader.
 */
export default function BookingDocuments({ booking, kind = ITINERARY, label = "Itinerary", compact = false }) {
  const files = bookingDocumentsOfKind(booking, kind);
  if (!files.length) return null;
  const open = (file, download) =>
    openFetchedFile(() => fetchBookingDocument(booking.id, file.id), file.fileName, download)
      .catch(() => alert(`Could not open the ${label.toLowerCase()}.`));
  if (compact) {
    return (
      <div className="small mt-1 d-flex flex-column gap-1">
        {files.map((file) => (
          <div key={file.id} className="d-flex align-items-center flex-wrap gap-1">
            <i className="bi bi-file-earmark-text" aria-hidden="true" />
            <span className="fw-semibold">{label}</span>
            {file.uploadedAt && <span className="text-muted">· {formatDateTimeDMY(file.uploadedAt, "")}</span>}
            <Button size="sm" variant="outline-secondary" className="py-0 px-2" onClick={() => open(file, false)}>View</Button>
            <Button size="sm" variant="outline-secondary" className="py-0 px-2" onClick={() => open(file, true)}>Download</Button>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="small mt-1 d-flex flex-column gap-1">
      {files.map((file) => (
        <div key={file.id} className="border rounded px-2 py-1 bg-light">
          <div className="fw-semibold text-truncate" title={file.fileName}>
            <i className="bi bi-file-earmark-text me-1" aria-hidden="true" />
            {label}: {file.fileName}
          </div>
          <div className="text-muted">
            {file.uploadedBy || "-"}{file.uploadedAt ? `, ${formatDateTimeDMY(file.uploadedAt, "")}` : ""}
          </div>
          <div className="d-flex gap-1 mt-1">
            <Button size="sm" variant="outline-secondary" className="py-0 px-2" onClick={() => open(file, false)}>View</Button>
            <Button size="sm" variant="outline-secondary" className="py-0 px-2" onClick={() => open(file, true)}>Download</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
